import _toConsumableArray from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for quantile transform nodes
 */

export var QuantileTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(QuantileTransformNode, _DataFlowNode);

  var _super = _createSuper(QuantileTransformNode);

  function QuantileTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, QuantileTransformNode);

    var _a, _b, _c;

    _this = _super.call(this, parent);
    _this.transform = transform;
    _this.transform = duplicate(transform); // duplicate to prevent side effects

    var specifiedAs = (_a = _this.transform.as) !== null && _a !== void 0 ? _a : [undefined, undefined];
    _this.transform.as = [(_b = specifiedAs[0]) !== null && _b !== void 0 ? _b : 'prob', (_c = specifiedAs[1]) !== null && _c !== void 0 ? _c : 'value'];
    return _this;
  }

  _createClass(QuantileTransformNode, [{
    key: "clone",
    value: function clone() {
      return new QuantileTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _a;

      return new Set([this.transform.quantile].concat(_toConsumableArray((_a = this.transform.groupby) !== null && _a !== void 0 ? _a : [])));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "QuantileTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _a = this.transform,
          quantile = _a.quantile,
          rest = __rest(_a, ["quantile"]);

      var result = Object.assign({
        type: 'quantile',
        field: quantile
      }, rest);
      return result;
    }
  }]);

  return QuantileTransformNode;
}(DataFlowNode);